import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { GraphqlService } from '@app/core/services/graphql/graphql.service';

interface HomeApiResponse {
  data?: { homeCollection?: { items?: any[] } };
}

export const homeResolver: ResolveFn<any> = async () => {
  const graphql = inject(GraphqlService);

  const resp = (await firstValueFrom(
    graphql.getHomeContent(),
  )) as HomeApiResponse;

  const base = resp?.data?.homeCollection?.items?.[0] ?? null;

  // Pre-compute SEO for SSR
  const title = base?.pageTitle?.trim?.() || 'Associate Schools Programme';

  const description =
    base?.metaDescription?.trim?.() ||
    'The RSC’s Associate Schools Programme: working with schools and theatres around the country to bring Shakespeare’s work to life through RSC Rehearsal Room Pedagogy.';

  const image =
    base?.image?.url ||
    'https://associateschools.rsc.org.uk/assets/images/rsc_logo.png';

  const url = 'https://associateschools.rsc.org.uk/';

  const seo = { title, description, image, url };

  return { base, seo };
};
